import Vue from 'vue';

import './sass/wax-lib-styles.css';
// INFO: use Vuetify here to compile template correctly
import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

Vue.prototype.$log = {
    // eslint-disable-next-line no-console
    info: console.log.bind(console),
    // eslint-disable-next-line no-console
    warn: console.warn.bind(console),
    // eslint-disable-next-line no-console
    error: console.error.bind(console),
};

export * from './classes';
export * from './components';
export * from './plugins';
export { WxRequest } from './lib/request';
export { generatePassword } from './lib/password';
